// Client for the ServiceLink flood determination integration (Lender.Optimus.Integrations). The
// orderable §17.1 flood product catalog backs both the RunFloodService loan-action editor's product
// override and the execution-time order-options prompt.
const BASE = '/api/servicelink-flood';

export class ServicelinkFloodApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getProducts() {
    return this.#http.get(`${BASE}/products`);
  }
}
